import { render, staticRenderFns } from "./legal_detial_new.vue?vue&type=template&id=65d7b2b2&scoped=true"
import script from "./legal_detial_new.vue?vue&type=script&lang=js"
export * from "./legal_detial_new.vue?vue&type=script&lang=js"
import style0 from "./legal_detial_new.vue?vue&type=style&index=0&id=65d7b2b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7b2b2",
  null
  
)

export default component.exports